import { ContactUs } from '@shared/interfaces/contactUs';
import { EMAIL, PHONE_NUMBER } from '@shared/constants/base';

export const CONTACTS: ContactUs[] = [
  {
    description: 'Send us an email',
    ariaLabel: 'Send us an email',
    alt: 'Send us an email',
    href: `mailto:${EMAIL}`,
    Icon: 'icons/send-email.svg',
  },
  {
    description: PHONE_NUMBER.layer,
    ariaLabel: 'Call us',
    alt: 'Call us',
    href: `tel:${PHONE_NUMBER.phone}`,
    Icon: 'icons/phone.svg',
  },
];
